import React, { ReactElement } from "react";
import { LabeledSelectInput } from "adviesbox-shared";
import { FormikContextType, connect } from "formik";
import { WoningState } from "../infra/woning-schema";
import { LabelValuePair } from "../../shared/types";
import { AdresInput } from "../../shared/components/adres/adres-input";
import FotoWoning from "../components/foto-woning";

const numberFormat = Intl.NumberFormat("nl", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});

type BestaandeWoningProps = {
  addressChangeKey: number;
  handleAddressChanged: () => void;
};

const BestaandeWoning = ({
  formik,
  addressChangeKey,
  handleAddressChanged
}: BestaandeWoningProps & {
  formik: FormikContextType<WoningState>;
}): ReactElement => {
  // Compute the index and selected woning directly from formik values to ensure it's always up-to-date
  const huidigeWoningIndex = formik.values.hypotheekOpWoning
    ? formik.values.huidigeWoningen.findIndex((x): boolean => x.pandId === formik.values.hypotheekOpWoning)
    : 0;

  const selectedHuidigeWoning =
    formik.values.hypotheekOpWoning && formik.values.huidigeWoningen.length > 0 && huidigeWoningIndex >= 0
      ? formik.values.huidigeWoningen[huidigeWoningIndex]
      : null;

  return (
    <>
      {formik.values.huidigeWoningen.length > 1 && (
        <LabeledSelectInput
          name="hypotheekOpWoning"
          caption="Hypotheek op woning"
          options={formik.values.huidigeWoningen.map(
            (bestaandeWoning): LabelValuePair => ({
              value: bestaandeWoning.pandId,
              label: `Woning ${bestaandeWoning.volgNummer}, Marktwaarde ${numberFormat.format(
                bestaandeWoning.marktwaardeBedrag ? bestaandeWoning.marktwaardeBedrag : 0
              )}`
            })
          )}
        />
      )}
      {selectedHuidigeWoning && (
        <>
          <AdresInput readonly={true} name={`huidigeWoningen.${huidigeWoningIndex}.adres`} />
          <FotoWoning
            fotoWoning={formik.values.huidigeWoningen[huidigeWoningIndex]?.fotoWoning || {}}
            adres={formik.values.huidigeWoningen[huidigeWoningIndex]?.adres || {}}
            modelPrefix={`huidigeWoningen.${huidigeWoningIndex}`}
            formik={formik}
            addressChangeKey={addressChangeKey}
            handleAddressChanged={handleAddressChanged}
          />
        </>
      )}
    </>
  );
};

export default connect<BestaandeWoningProps, WoningState>(BestaandeWoning);
